module.exports = __webpack_public_path__ + "img/xdgslg_tip_ico.5d256aa9.png";